type AnyRecord = Record<string, unknown>

function asRecord(value: unknown): AnyRecord | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null
  return value as AnyRecord
}

/** Fractional index on checkpoint user-layer element references (next to objectId / decodedData). */
export function readFractionalIndexFromCheckpointElement(element: unknown): string | undefined {
  const r = asRecord(element)

  if (!r) return undefined

  const v = r.fractionalIndex ?? r.FractionalIndex ?? r.fractional_index

  return typeof v === 'string' && v.trim() !== '' ? v.trim() : undefined
}

/** After unwrapping a StowedElement, fractionalIndex may still sit on the merged root. */
export function readFractionalIndexFromDecodedRecord(decodedData: unknown): string | undefined {
  const r = asRecord(decodedData)

  if (!r) return undefined

  const v = r.fractionalIndex ?? r.FractionalIndex ?? r.fractional_index

  return typeof v === 'string' && v.trim() !== '' ? v.trim() : undefined
}
